<template>
  <section class="hero svgbg">
    <div class="hero-body">
      <div class="container">
        <h1 class="title" :style="'vertical-align: sub;color:' + color">
          <img
            :src="getImgUrl(this.$router.currentRoute.params.name)"
            :alt="'suite-' + this.$router.currentRoute.params.name"
            style="vertical-align: bottom;"
          />
          {{ title }}
          <b-button
            class="is-pulled-right"
            tag="router-link"
            :to="{ path: '/' }"
          >
            <i class="fa fa-undo-alt"></i>
          </b-button>
        </h1>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'HeaderModules',
  props: {
    title: String,
    color: String,
  },
  data() {
    return {
      mdl: 'HeaderModules',
    };
  },
  methods: {
    getImgUrl(pic) {
      return require('@/assets/suites/' + pic + '.png');
    },
  },
};
</script>
